import { MoveLeftIcon, MoveRightIcon } from 'lucide-react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useClipboard } from 'use-clipboard-copy';
import Typewriter from 'typewriter-effect';
import useGeneratorStore from '@/state/generator-store';
import { useNewUserFlowStartShow } from '@/state/show-store';

const NewUserPage = () => {
  const [IsTypewriterDone, setIsTypewriterDone] = useState(false);
  const [IsDescriptionDone, setIsDescriptionDone] = useState(false);
  const { isShow: flowStartShow } = useNewUserFlowStartShow();
  const typewriterFunc = useRef<{ start: () => void } | null>(null);

  useEffect(() => {
    if (typewriterFunc.current && flowStartShow) {
      typewriterFunc.current.start();
    }
  }, [flowStartShow]);

  return (
    <div className="h-full justify-between flex  flex-col-reverse">
      <div className=" justify-between flex flex-col items-center  gap-[8px]" style={{ height: '50%', paddingBottom: '60px' }}>
        <div>
          <div className=" text-jen-size-heading-01 text-center mb-[21px] 2xl:text-[54px]" style={{}}>
            <Typewriter
              options={{
                delay: 40,
                cursorClassName: 'text-jen-interactive-primary ml-[2px] animate-blink font-bold text-black',
              }}
              onInit={(typewriter) => {
                typewriterFunc.current = {
                  start: () => {
                    typewriter
                      .typeString('Let’s make your first song. What should it sound like?')
                      .callFunction(() => {
                        setIsTypewriterDone(true);
                      })
                      .start();
                  },
                };
              }}
            />
          </div>
          {IsTypewriterDone && (
            <div
              onAnimationEnd={() => {
                setIsDescriptionDone(true);
              }}
              className=" w-[541px] animate-fadeIn  text-jen-size-heading-04 text-jen-content-secondary text-center mx-auto"
            >
              Describe your track in the Generator Bar below or pick one of the example prompts we’ve spun up for you.
            </div>
          )}
        </div>
        {IsDescriptionDone && <PromptCopyList className=" animate-fadeIn" />}
      </div>
    </div>
  );
};
const promptList = [
  'Create a chill lo-fi hip-hop beat with mellow piano chords, subtle vinyl crackle, and a relaxed groove that feels like a rainy afternoon by the window.',
  'Compose a bright, upbeat pop track with a catchy melody, driving synths, and vibrant energy that captures the joy of a summer festival.',
  'Generate a serene orchestral piece with a flowing string section, gentle piano, and soft woodwinds, evoking the calm of a sunrise over a quiet lake.',
  'Craft an intense heavy metal song with blistering guitar riffs, thunderous drums, and a powerful, adrenaline-pumping energy that feels like an epic battle.',
  'Produce a dreamy ambient track with lush synthesizer pads, subtle rhythmic textures, and a floating feeling that transports the listener to a cosmic landscape.',
];

export const PromptCopyList = ({ className, onClickPrompt }: { className?: string; onClickPrompt?: (val: string) => void }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { generatorForm } = useGeneratorStore();

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % promptList.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? promptList.length - 1 : prevIndex - 1));
  };

  const clipboard = useClipboard();

  const handleCopy = useCallback(() => {
    const prompt = promptList[currentIndex];
    generatorForm?.setValue('prompt', prompt);
    onClickPrompt?.(prompt);
    clipboard.copy(prompt);
  }, [currentIndex]);

  return (
    <div
      className={`${className} box-content pt-[44px] px-[36px] flex flex-col gap-[6px] w-[332px] bg-[linear-gradient(0deg,_#17191A_0%,_#1E2021_100%)]`}
    >
      <div className="text-[10px] text-jen-interactive-primary leading-3">USE PROMPT EXAMPLE</div>
      <div
        className="text-jen-background-tertiary text-[12px]  tracking-[-0.14px] transition-all duration-300 cursor-pointer"
        onClick={handleCopy}
      >
        {promptList[currentIndex]}
      </div>
      <div className="gap-[10px] mt-[16px] flex cursor-pointer">
        <MoveLeftIcon color="#ff5b27" width={15} onClick={handlePrev} />
        <MoveRightIcon color="#ff5b27" width={15} onClick={handleNext} />
      </div>
    </div>
  );
};
export default NewUserPage;
